"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _accordion = _interopRequireWildcard(require("../accordion"));
var _pill = _interopRequireDefault(require("../pill"));
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const FiltersSmall = _ref => {
  let {
    children,
    countDisplay,
    onClick,
    idPrefix,
    heading
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_accordion.default, {
    headerElement: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, heading || 'Filters'), countDisplay && /*#__PURE__*/_react.default.createElement(_pill.default, {
      className: _indexModule.default.accordionCount,
      type: "secondary",
      dataTestId: idPrefix && "".concat(idPrefix, "-items-count-small")
    }, countDisplay)),
    type: _accordion.AccordionSize.Small,
    classNames: _indexModule.default,
    id: idPrefix && "".concat(idPrefix, "-filters"),
    onClick: onClick
  }, children);
};
var _default = exports.default = FiltersSmall;